export const RD_USER_KEY = 'sedhoUserKey'
export const RD_AUTH_TOKEN = 'sedhoToken'
